// Group.js
import React, { forwardRef } from 'react';

const Group = forwardRef(({ 
  rotationX = 0, 
  rotationY = 0, 
  rotationZ = 0, 
  panX = 0, 
  panY = 0, 
  translateZ = 0,
  scale = 1,
  onClick,
  children
}, ref) => {
  return (
    <div 
      ref={ref}
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) onClick();
      }}
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: `translate(-50%, -50%) translate3d(${panX}px, ${panY}px, ${translateZ}px) rotateX(${rotationX}deg) rotateY(${rotationY}deg) rotateZ(${rotationZ}deg) scale(${scale})`,
        transformOrigin: 'center center',
        zIndex: 5
      }}
    >
      {children}
    </div>
  );
});

export default Group;